/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/no-unescaped-entities */
import { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Button, Loader } from 'ypf-pas-general-ui-components';
import { BsChevronLeft } from 'react-icons/bs';
import { VscCopy } from 'react-icons/vsc';
import { Col, Row } from 'react-bootstrap';

import { getDetailsHeader } from '../../../services/serviceRequest';
import PillStatus from '../../../components/PillStatus/PillStatus';
import useToast from '../../../hooks/useToast';
import useRequestDetailPermissions from '../../../hooks/useRequestDetailPermissions';
import { assignmentTypeEnum } from '../../../utils/dataStatus';
import { aprobador, proveedorNotificador, solicitante } from '../../../security/constantsRols';
import { checkRol } from '../../../security';

import UbicationCard from './UbicationCard/UbicationCard';
import TabsDetail from './TabsDetail/TabsDetail';
import Description from './Description/Description';
import AddEventModal from './AddEventModal/AddEventModal';

import './DetailServiceRequest.scss';

const DetailServiceRequest = () => {
  const history = useHistory();
  const [details, setDetails] = useState();
  const [loading, setLoading] = useState(true);
  const [withOutEventAssigned, setWithOutEventAssigned] = useState();
  const [pendingEvent, setPendingEvent] = useState(false);
  const [activeTab, setActiveTab] = useState('solicitado');
  const { setNewToast } = useToast();

  const { id } = useParams();

  const getDetailsHeaders = async () => {
    try {
      const detailsHeader = await getDetailsHeader(id);

      setWithOutEventAssigned(detailsHeader?.sinEventoAsignado && checkRol(proveedorNotificador));
      setPendingEvent(detailsHeader?.sinEventoAsignado && checkRol(proveedorNotificador));
      setDetails(detailsHeader);
      if (detailsHeader) {
        setLoading(false);
      }
    } catch (error) {
      setNewToast({
        type: 'ERROR',
        message: error.message
      });
    }

    return null;
  };

  const handleOpenCloseModalOfAddEvent = (openClose) => {
    if (checkRol(aprobador) && details?.esEditable) {
      setPendingEvent(openClose);

      return;
    }

    setPendingEvent(openClose);
  };

  useEffect(() => {
    getDetailsHeaders();
  }, [id]);

  const accepted = details?.proveedoresAceptados;
  const reject = details?.proveedoresRechazados;
  const totally = details?.proveedoresTotales;
  const responsetotally = accepted + reject === totally;
  const pastTime = details?.pasoFechaRespuesta;
  const styleJustify = pastTime ? 'header-detail-justify' : 'header-detail';
  const idStatus = details?.estadoEnum;
  const codigo = details?.numero;
  const isAsds = details?.tipoAsignacion?.id === assignmentTypeEnum.Automatica;
  const isOyM = details?.tipoUbicacion.id > 2;

  const { permissions } = useRequestDetailPermissions({
    notifyTo: details?.tipoNotificacionEnum,
    isASDS: isAsds,
    isOyM
  });

  return (
    <div className="container container-detail-service-request">
      {loading && <Loader show text="CARGANDO ..." />}
      <div className={`${styleJustify}`}>
        <div className="title">
          <Button
            colorIcon="primary"
            icon={BsChevronLeft}
            onClick={() => {
              history.push(checkRol(aprobador) && !checkRol(solicitante) ? '/approver' : '/');
            }}
            type="button"
            variant="white"
            widthButton="42px"
          />
          <h2>Solicitud de servicio N° {codigo}</h2>
        </div>
        <Row className="align-items-center">
          <Col md={5} sm={5}>
            <PillStatus
              accepted={accepted}
              idStatus={idStatus}
              pastTime={pastTime}
              reject={reject}
              responsetotally={responsetotally}
              totally={totally}
            />
          </Col>
          {permissions.replySDS && !isOyM && (
            <Col md={6} sm={6}>
              <button
                className={`reply-sds-button ${pastTime ? 'mx-3' : ''}`}
                onClick={() => {
                  history.push({
                    pathname: '/createMultiple',
                    previusPath: `detail/${id}`,
                    idSDSToReply: id
                  });
                }}
                type="button"
              >
                <span>Replicar</span>
                <VscCopy />
              </button>
            </Col>
          )}
        </Row>
      </div>

      {details && (
        <>
          <UbicationCard
            details={details}
            idStatus={idStatus}
            setPendingEvent={handleOpenCloseModalOfAddEvent}
            tpyeAndObjectImputationPermissions={permissions.typeAndObjectImputation}
            withOutEventAssigned={withOutEventAssigned}
          />
          <Description details={details} setActiveTab={setActiveTab} />
        </>
      )}
      <TabsDetail
        activeTab={activeTab}
        details={details}
        idStatus={idStatus}
        isOyM={isOyM}
        permissions={permissions}
        setActiveTab={setActiveTab}
      />
      {pendingEvent && (
        <AddEventModal
          requestId={id}
          setShowAddEventModal={handleOpenCloseModalOfAddEvent}
          setWithOutEventAssigned={setWithOutEventAssigned}
          showAddEventModal={pendingEvent}
          ubicationType={details?.tipoUbicacion}
        />
      )}
    </div>
  );
};

export default DetailServiceRequest;
